import { StyledTextField } from "./CommentBox.styles";

export default function CommentBox({ onChange, value }) {
    return (
        <StyledTextField
            variant="outlined"
            placeholder="Add a note (e.g. grouping) about this quote..."
            multiline
            minRows={1}
            maxRows={1}
            value={value}
            onChange={onChange}
            fullWidth
        />
    );
}